import { DataSupplier, ModificationState, TyreArticleAttribute } from "@tm/models"

export function createTyreArticleAttributeFromSupplier(supplier: DataSupplier) {
    const articleAttribute: TyreArticleAttribute = {
        group: "manufacturer",
        id: supplier.id,
        value: supplier.name,
        description: "",
        abbreviation: supplier.abbreviation,
        text: "",
        key: "",
        unit: "",
        modificationState: ModificationState.NotModified,
        highlight: false,
        sortNo: 0,
        isBlockSeperator: false,
        isOptimized: false,
        query: supplier.id?.toString() || "",
    }

    return articleAttribute
}
